import { Longhand } from "../longhand.js";
import Base from "./margin-top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/margin-bottom}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=margin-bottom.js.map